import { DotMatrix } from '@clickguard/design-system'
import { BlacklistPageFiltersContextProvider } from './context'
import { lazy, Suspense } from 'react'
import { useFilterPersistence } from '../../../../hooks/use-filter-presistence'

const BlacklistPageView = lazy(() =>
	import('./view')
		.then((module) => {
			return { default: module.BlacklistPageView }
		})
		.catch((error) => {
			console.error('Failed to load:', error)
			return { default: () => <div>Error loading the component.....</div> }
		})
)
export const BlacklistPage = () => {
	useFilterPersistence()
	return (
		<BlacklistPageFiltersContextProvider>
			<Suspense
				fallback={
					<div className="flex justify-center py-16">
						<DotMatrix size="lg" />
					</div>
				}
			>
				<BlacklistPageView />
			</Suspense>
		</BlacklistPageFiltersContextProvider>
	)
}
